import { render } from "./PledgeRepairButton.vue?vue&type=template&id=17713484"
import script from "./PledgeRepairButton.vue?vue&type=script&lang=js"
export * from "./PledgeRepairButton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__